import type { DomainDef } from '@/lib/domainSchema'
import { TruthFieldRow } from './TruthFieldRow'

interface TruthCardProps {
  domain: DomainDef
  /** Single-domain slice from `StructuredBusinessContext[domainKey]`. */
  section: Record<string, unknown> | undefined
}

/**
 * Single rounded card listing every sub-field of one domain as a
 * labelled, read-only row. The card mirrors the prototype's `truth-card`
 * aesthetic (border + bg-elevated + sp-5 padding + rounded-lg) but with
 * sub-field rows instead of a single summary line.
 */
export function TruthCard({ domain, section }: TruthCardProps) {
  return (
    <article
      data-testid={`truth-card-${domain.key}`}
      className="rounded-lg border border-border-default bg-bg-primary p-5"
    >
      <div className="flex flex-col">
        {domain.fields.map((field) => (
          <TruthFieldRow
            key={field.key}
            field={field}
            value={section?.[field.key]}
          />
        ))}
      </div>
    </article>
  )
}
